import { useLoaderData } from '@tanstack/react-router';

import { ObjectsTable } from '@/features/project-details/objects-table';

export const ProjectObjectsPage = () => {
  const project = useLoaderData({
    from: '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout',
  });

  return <ObjectsTable project={project} />;
};
